<template>
    <div>

        <h2 class="mb-8">{{ __('general.logo') }}</h2>

        <div class="d-flex flex-wrap flex-column flex-lg-row align-items-center">
            <div class="col-8 col-lg-5 col-2xl-4 mx-auto image-container">
                <img v-if="dataLogo"
                     :src="dataLogo"
                     alt="Geschaeftslogo">
                <img v-else width="100%"
                     src="images/image_thumbnail.jpg"
                     alt="placeholder image">
            </div>

            <div class="col-lg-6 ml-auto mt-10 mt-lg-0">
                <p class="text-center font-weight-bold">{{ __('store.logo_max1') }}</p>
                <div class="d-flex flex-wrap justify-content-center text-center">
                    <div v-if="!dataLogo" class="form-group w-75">
                        <label for="fileSelection" class="btn btn-primary my-4 font-weight-bolder w-100">
                        <span class="svg-icon svg-icon-md">
                            <i class="fa fa-upload"></i>
                        </span>
                            {{ __('store.upload_logo') }}
                        </label>
                    </div>
                    <input id="fileSelection" type="file" class="d-none"
                           accept="image/jpeg,image/jpg,image/png,image/svg" @change="uploadFiles">

                    <div v-if="dataLogo" class="form-group w-75">
                        <label for="fileSelectionChange" class="btn btn-primary mb-4 font-weight-bolder w-100">
                        <span class="svg-icon svg-icon-md">
                            <i class="fas fa-exchange-alt"></i>
                        </span>
                            {{ __('store.change_logo') }}
                        </label>
                    </div>
                    <input id="fileSelectionChange" type="file" class="d-none"
                           accept="image/jpeg,image/jpg,image/png,image/svg" @change="uploadFiles($event,true)">

                    <div v-if="dataLogo" class="form-group w-75">
                        <button @click="deleteImage(false)" class="btn btn-primary font-weight-bolder w-100"><span
                            class="svg-icon svg-icon-md"><i
                            class="fas fa-trash"></i></span>{{ __('store.delete_logo') }}
                        </button>
                    </div>
                    <span class="form-text text-muted"><strong>{{ __('store.logo_rules') }}</strong></span>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import Navigation from './Nav/Navigation.vue'

export default {
    layout: Navigation,

    name: 'EditStoreLogo',

    props: {
        storeLogo: String,
        storeUuid: String,
    },

    data() {
        return {
            dataLogo: '',
        }
    },

    mounted() {
        this.dataLogo = this.storeLogo
    },

    methods: {
        uploadFiles(event, changed) {
            let files = event.target.files

            this.$inertia.post(this.$route('store-logo.store', [this.storeUuid]).url(), {
                logo: files[0],
                changed: changed,
            }, {
                only: ['storeLogo', 'flash'],
                onSuccess: (response) => {
                    this.dataLogo = response.props.storeLogo
                },
                onFinish: () => {
                    event.target.value = ''
                },
            })
        },

        async deleteImage(changed) {
            await Swal.fire({
                title: !changed ? this.__('store.image_update_confirm') : this.__('store.image_delete_confirm'),
                showDenyButton: false,
                showCancelButton: true,
                confirmButtonText: this.__('general.yes'),
                cancelButtonText: this.__('actions.abort'),
                width: '75%',
            }).then((result) => {
                if (result.isConfirmed) {
                    this.$inertia.post(this.$route('store-logo.delete', [this.storeUuid]), {}, {
                        only: ['storeLogo', 'flash'],
                        onSuccess: () => {
                            this.dataLogo = null
                        },
                    })
                }
            })
        },
    },
}
</script>